// extracted by mini-css-extract-plugin
export var projects = "projects-module--projects--NBQ4+";
export var categories = "projects-module--categories--bm7Or";
export var catheader = "projects-module--catheader--O5ZGu";
export var linebreak = "projects-module--linebreak--y8t0f";
export var categoriesBody = "projects-module--categoriesBody--3rqZT";
export var categoriesTypes = "projects-module--categoriesTypes--M4Moz";
export var active = "projects-module--active--WOjR7";
export var projectlisttitle = "projects-module--projectlisttitle--dhrXN";
export var projectlist = "projects-module--projectlist--mGWwI";
export var bottomSection = "projects-module--bottomSection--CERwC";
export var title = "projects-module--title--a2vwW";